<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-md-6 col-sm-12">
            <div class="card">            
                <div class="p-3 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Reporte Fotográfico</h6>
                  </div>
                </div>
                <div class="card-body">
									<div class="row">
										<div class="col-md-12">
											<label for="example-text-input" class="form-control-label"
												>Seleccione contrato</label
											>
                      <Select2 v-model="constracts" :options="constracts" />
											<select name="contract" v-model="contract" id="contract" class="form-control">
												<option  v-for="(contract, index) in constracts" :key="index" :option="contract.value">{{ contract.text }}</option>
											</select>
										</div>
										<div class="col-md-12">
											<div class="text-center">
												<argon-button
													class="mt-4"
													color="danger"
													fullWidth
													size="lg"
													@click="getReport"
												>Generar</argon-button>
                    </div>
										</div>
									</div>
								</div>
            </div>
        </div>
				<div class="col-md-6 col-sm-12" v-if="isLoading">
					<div class="card">            
            <div class="p-3 card-header">
              <div class="d-flex justify-content-between">
                
              </div>
            </div>
            <div class="card-body">
							<h6 class="mb-2 text-center">Generando...</h6>
							<Loading />
						</div>
					</div>
				</div>
      </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import Loading from '../../examples/Loading.vue';
import axios from 'axios';
import { jsPDF } from "jspdf";
import moment from "moment";

  export default {
    name: "tables",
    components: {
			Loading,
			ArgonButton
    },
    data() {
      return {
        constracts:[],
				installs:[],
        isLoading:false,
				contract:null,
        reportPDF:null,
        downloaded:false
      };
    },
    methods:{
      async fetchContracts(){
        let id=localStorage.getItem('AccountId'); 
        fetch(this.$EndPoint+'campanas/get_by_account/'+id)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.constracts=result.map(item=> {return {text:item.Name+' - ' +item.NombreCampana__c, value: item.Name}});
        })
      },

			getReport(){
				this.isLoading=true;
        let token=null;
        axios.post(this.$EndPoint+'users/sptoken  ')
        .then((result)=>{
          console.log(result.data);
          token= result.data;
          localStorage.setItem('spToken', token);
          this.generatePDF();
        }) 
			},

      async generatePDF(){
        return new Promise( (resolve) => {
          this.reportPDF = new jsPDF("landscape");
          let self= this;
          console.log(this.contract);
          fetch(this.$EndPoint+'instalaciones/get_by_contract/'+this.contract)
          .then(response=>response.json())
          .then(async function(result){
            console.log(result);
            self.installs=result;
            if(self.installs.length>0){
              self.reportPDF.addImage("/img/dicora.1830d239.png", "PNG", 110, 40, 86, 24,"center");
              self.reportPDF.setFont("times", "bold");
              self.reportPDF.setDrawColor("#b4243a");
              self.reportPDF.setLineWidth(4);
              self.reportPDF.line(10, 120, 10, 250); // vertical line
              self.reportPDF.line(0, 200, 100, 200); // horizontal line
              self.reportPDF.setDrawColor("#8c8c8c");
              self.reportPDF.line(285, 0, 285, 120); // vertical line
              self.reportPDF.line(300, 10, 200, 10); // horizontal line
              self.reportPDF.setTextColor("#b4243a"); 
              self.reportPDF.setFontSize(26);
              self.reportPDF.text('REPORTE FOTOGRÁFICO',150, 100, null, null, "center");
              self.reportPDF.setFontSize(18);
              self.reportPDF.text('NÚMERO DE CONTRATO '+self.contract,150, 120, null, null, "center");
              self.reportPDF.text(self  .installs[0].Marca__c,150, 140, null, null, "center");
              self.reportPDF.addPage();
              let dateInst;

              for (const row of self.installs){
                if(row.Estado__c=='Instalada'){
                  if(row.FechaInstalacion__c!=null){
                    dateInst=self.getFormattedDate(row.FechaInstalacion__c);
                  }
                  let ubi = ((!row.UbicacionEnSitio__c) ? '': row.UbicacionEnSitio__c);
                  let title=row.Marca__c+' - '+row.Sitio__c+' - '+ubi+ ' - '+ dateInst;
                  if(row.Foto1URL__c!=null){
                    //self.reportPDF.addImage("/img/dicora.1830d239.png", "PNG", 43, 25, 55, 80,'ins1'+row._id,+'back');
                    await self.fetchImg(row.Foto1URL__c,  43, 25, 55, 80,'ins1'+row._id,1);
                  }
                  if(row.Foto2URL__c!=null){
                    //self.reportPDF.addImage("/img/dicora.1830d239.png", "PNG", 43, 120, 55, 80,'ins2'+row._id,+'back');
                    await self.fetchImg(row.Foto2URL__c, 43, 120, 55, 80,'ins2'+row._id,2);
                  }
                  if(row.Foto3URL__c!=null){
                    //self.reportPDF.addImage("/img/dicora.1830d239.png", "PNG", 183, 25, 55, 80,'ins3'+row._id,+'back');
                    await self.fetchImg(row.Foto3URL__c,  183, 25, 55, 80,'ins3'+row._id,3,title);
                  }
                  //self.reportPDF.addPage();
                }else if(row.Estado__c=='Pendiente Resolución'){
                  let title= row.Marca__c+' - '+row.Sitio__c+' - '+row.UbicacionEnSitio__c+' - NO INSTALADA';
                  if(row.FotoVisita1URL__c!=null){
                    await self.fetchImg(row.FotoVisita1URL__c, 43, 25, 55, 80,'pend1'+row._id,1);
                  }
                  if(row.FotoVisita2URL__c!=null){
                    await self.fetchImg(row.FotoVisita2URL__c, 43, 120, 55, 80,'pend2'+row._id,2);
                  }
                  if(row.FotoVisita3URL__c!=null){
                    await self.fetchImg(row.FotoVisita3URL__c,183, 25, 55, 80,'pend3'+row._id,3, title);
                  }
                  //self.reportPDF.addPage();
                }
              }
              resolve();   
              setTimeout(self.downloadPDF,10000);
            }else{
              self.$swal({
                title: 'No se encontraron registros',
                icon:'warning',
                color:'#b4243a',
                confirmButtonText:'Aceptar',
                buttonsStyling:false,
                customClass:{
                  confirmButton:'btn btn-danger'
                },
                confirmButtonColor:'#b4243a',
                showClass: {
                  popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                  popup: 'animate__animated animate__fadeOutUp'
                }
              });
              self.isLoading=false;
            }
            
          })
        });
      },

      downloadPDF(){
        console.log('Generating PDF');
        let dateNow = moment(Date.now()).format("YYYY_MM_DD_HH:mm:ss.SSS");

        this.reportPDF.save('Reporte_'+this.contract+'_'+dateNow+'.pdf');
        this.isLoading = false;
      },

      async fetchImg(url, x, y, width, height,id,cnt, title){
        let self=this;
        let imgResult = null;
        const token = localStorage.getItem('spToken');
        // Verifica si hay un token disponible
        if (!token) {
          console.error('No se encontró un token de acceso en el almacenamiento local.');
        } else {
          let startIndex = url.indexOf('/sites');
          let modifiedURL = url.slice(startIndex);
          let baseUrl = 'https://dicoracom.sharepoint.com/sites/Instalaciones/_api/web';
          let moddURL = `/GetFileByServerRelativeUrl('${modifiedURL}')/openbinarystream`;
          let newUrl = `${baseUrl}${moddURL}`;
          self.reportPDF.setTextColor("#8c8c8c"); 
          self.reportPDF.setFont("times", "regular");
          self.reportPDF.setFontSize(12);  
          axios.get(newUrl, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            responseType: 'arraybuffer' // Para manejar la respuesta como un arreglo de bytes (imagen)
          })
          .then((response) => {
            // Aquí puedes manejar la respuesta de la imagen
            console.log(response); // La respuesta será un arreglo de bytes de la imagen
            imgResult = response.data;
            
            function arrayBufferToBase64(buffer) {
              let binary = '';
              let bytes = new Uint8Array(buffer);
              let len = bytes.byteLength;
              for (let i = 0; i < len; i++) {
                  binary += String.fromCharCode(bytes[i]);
              }
              return window.btoa(binary);
            }
           
            //self.reportPDF.addPage();
            
            console.log(cnt);
            switch(cnt){
              case 1:
                self.reportPDF.setFillColor("#b4243a");
                self.reportPDF.rect(10, 20, 120, 90, "F");
                break;
              case 2:
                self.reportPDF.setFillColor("#8c8c8c");
                self.reportPDF.rect(10, 115, 120, 90 , "F");
                break;
              case 3:
                self.reportPDF.setFillColor("#b4243a");
                self.reportPDF.rect(150, 20, 120, 90, "F");
                break;
            }

            self.reportPDF.addImage(arrayBufferToBase64(imgResult), "JPEG", x, y, width, height, id);
            
            if (cnt==3){
              self.reportPDF.text(title ,10, 10, null, null, "left");
              self.reportPDF.setDrawColor("#b4243a");
              self.reportPDF.line(0, 15, 150, 15); // horizontal line
              self.reportPDF.setDrawColor("#8c8c8c")
              self.reportPDF.line(150, 15, 300, 15); // horizontal line
              self.reportPDF.addPage();
            }
           return imgResult;
          })
          .catch((error) => {
              console.log(error);
              console.error('Error al obtener la imagen:', error.response ? error.response.data : error.message);
          });
        }
      },
      getFormattedDate(date) {
        return moment(date).format("YYYY-MM-DD")
      }

    },
    created(){
      if(localStorage.getItem('IsLoggedIn')=='true'){
        this.fetchContracts();
      }else{
        this.$router.push('/signin')
      }
    }
  };
</script>
<style>
.hidden{
  display:none !important;
}
</style>